module.exports = __webpack_public_path__ + "assets/img/banner6.b61aad92.png";